import React, { useEffect, useState, useRef } from 'react';

export const NewsletterPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');

  const [emailError, setEmailError] = useState(false);

  const [turnstileToken, setTurnstileToken] = useState<string | null>(null);
  const [captchaError, setCaptchaError] = useState<boolean>(false);

  const formRef = useRef<HTMLFormElement>(null);

  const isEmailValid =
    email.trim() !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleClose = () => {
    localStorage.setItem('orqa_newsletter_dismissed', 'true');
    setIsOpen(false);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!isEmailValid) {
      setEmailError(true);
      return;
    }

    if (!turnstileToken) {
      setCaptchaError(true);
      return;
    }

    if (!formRef.current) return;

    const formData = new FormData(formRef.current);
    formData.append('cf-turnstile-response', turnstileToken);

    setTurnstileToken(null);
    if ((window as any).turnstile) {
      (window as any).turnstile.reset();
    }

    localStorage.setItem('orqa_newsletter_dismissed', 'true');
    setIsOpen(false);

    fetch('https://salesforce-form-proxy.orqa.workers.dev', {
      method: 'POST',
      body: formData,
    });
  };

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('orqa_newsletter_dismissed');
    if (!hasSeenPopup) {
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    (window as any).onNewsletterTurnstileSuccess = (token: string) => {
      setTurnstileToken(token);
      setCaptchaError(false);
    };

    const scriptId = 'cf-turnstile-script-newsletter';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    return () => {
      delete (window as any).onNewsletterTurnstileSuccess;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="program-popup-container">
      <div className="program-popup-content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          onClick={handleClose}
          style={{
            width: '24px',
            height: '24px',
            aspectRatio: '1/1',
            position: 'absolute',
            right: '8px',
            top: '8px',
            cursor: 'pointer',
          }}
        >
          <path
            d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
            fill="black"
            fillOpacity="0.3"
          />
        </svg>

        <h2 className="program-popup-title">DEVELOPER UPDATES</h2>

        <p className="program-popup-description">
          Get the latest news on our developer program sent straight to your
          inbox.
        </p>

        <div
          style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <form
            className="program-popup-form"
            onSubmit={handleSubmit}
            ref={formRef}
            noValidate
          >
            <input type="hidden" name="oid" value="00Dfn000006LhOH" />
            <input type="hidden" name="retURL" value="https://orqafpv.com" />
            <input type="hidden" name="lead_source" value="Newsletter Popup" />

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <input
                className="program-popup-input"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                  if (emailError) setEmailError(false);
                }}
                id="email"
                name="email"
                required
              />
            </div>

            <button type="submit" className="program-popup-submit-btn">
              Subscribe
            </button>
          </form>

          {emailError && (
            <span
              style={{
                color: '#FF2238',
                fontSize: '12px',
                marginTop: '4px',
                marginLeft: '2px',
                textAlign: 'left',
              }}
            >
              Please enter a valid email address
            </span>
          )}
        </div>

        <div
          style={{
            marginTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            className="cf-turnstile"
            data-sitekey={process.env.REACT_APP_DATA_SITE_KEY}
            data-callback="onNewsletterTurnstileSuccess"
            data-theme="light"
            data-appearance="interaction-only"
          />
          {captchaError && (
            <span
              style={{ color: '#FF2238', fontSize: '12px', marginTop: '4px' }}
            >
              Please complete the security check
            </span>
          )}
        </div>

        <span
          style={{
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.60)',
          }}
        >
          No spam, ever. We promise.
        </span>
      </div>
    </div>
  );
};
